import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ContentWithPaddingXl, Container } from "components/misc/Layouts.js";
import { SectionHeading as Heading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";
import PropTypes from "prop-types";

const Subheading = tw(SubheadingBase)`text-center`;
const Testimonials = tw.div`flex flex-col lg:flex-row items-center lg:items-stretch`;
const TestimonialContainer = tw.div`mt-16 lg:w-1/3`;
const Testimonial = tw.div`px-4 text-center max-w-xs mx-auto flex flex-col items-center`;
const Image = tw.img`w-20 h-20 rounded-full`;
const Quote = tw.blockquote`mt-5 text-gray-600 font-medium leading-loose`;
const CustomerName = tw.p`mt-5 text-gray-900 font-semibold uppercase text-sm tracking-wide`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute left-0 top-0 h-56 w-56 opacity-15 transform -translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute right-0 bottom-0 h-64 w-64 opacity-15 transform translate-x-2/3 text-yellow-500`}
`;

const ArrowButton = styled.button`
  ${tw`absolute top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 rounded-full p-2 shadow-md hover:bg-primary-500 hover:text-white transition-colors duration-200 z-10`}
`;

const ThreeColumnWithProfileImage = ({
  cards = [],
  subheading = "Testimonials",
  heading = "Customer's Review"
}) => {
  const [startIdx, setStartIdx] = useState(0);
  const maxVisible = 3;
  const canGoLeft = startIdx > 0;
  const canGoRight = startIdx + maxVisible < cards.length;

  const handleLeft = () => {
    if (canGoLeft) setStartIdx(startIdx - 1);
  };
  const handleRight = () => {
    if (canGoRight) setStartIdx(startIdx + 1);
  };

  const visibleCards = cards.slice(startIdx, startIdx + maxVisible);

  return (
    <>{cards.length > 0 &&
      <Container tw="relative">
        <ContentWithPaddingXl>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          <div className="relative flex items-center">
            {canGoLeft && (
              <ArrowButton style={{ left: 0 }} onClick={handleLeft} aria-label="Previous">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
              </ArrowButton>
            )}
            <Testimonials tw="w-full justify-center">
              {visibleCards.map((visitor) => (
                <TestimonialContainer key={visitor.imageSrc || visitor.customerName}>
                  <Testimonial>
                    <Image src={visitor.imageSrc} />
                    <Quote>"{visitor.quote}"</Quote>
                    <CustomerName>- {visitor.customerName}</CustomerName>
                  </Testimonial>
                </TestimonialContainer>
              ))}
            </Testimonials>
            {canGoRight && (
              <ArrowButton style={{ right: 0 }} onClick={handleRight} aria-label="Next">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </ArrowButton>
            )}
          </div>
        </ContentWithPaddingXl>

        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </Container>
    }
    </>
  );
};

ThreeColumnWithProfileImage.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      imageSrc: PropTypes.string,
      quote: PropTypes.string,
      customerName: PropTypes.string,
    })
  ),
  subheading: PropTypes.string,
  heading: PropTypes.string,
};

export default ThreeColumnWithProfileImage;
